module.exports = __webpack_public_path__ + "img/img_04.f2447fe2.png";